import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { UIModule } from '../ui.module';

import { NwMenuRoutingModule } from './nw-menu.routing';
import { NwMenuComponent } from './nw-menu.component';
import { ServerItemComponent } from './server-item/server-item.component';
import { ServerFormComponent } from './server-form/server-form.component';
import { ServerStartComponent } from './server-start/server-start.component';
import { TutorialAlertComponent } from './tutorial-alert/tutorial-alert.component';
import { BackgroundComponent } from './background/background.component';

import { ServerStartDirective } from './server-start.directive';
import { ServerVersionDataDirective } from './server-version-data.directive';

import { NwMenuService } from './nw-menu.service';
import { ServerVersionDataService } from './server-version-data.service';

@NgModule({
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,

        CoreModule,
        SharedModule,
        UIModule,

        NwMenuRoutingModule
    ],
    declarations: [
        NwMenuComponent,
        ServerItemComponent,
        ServerFormComponent,
        ServerStartComponent,
        TutorialAlertComponent,
        BackgroundComponent,

        ServerStartDirective,
        ServerVersionDataDirective
    ],
    entryComponents: [
        NwMenuComponent,
        BackgroundComponent
    ],
    providers: [
        NwMenuService,
        ServerVersionDataService
    ]
})
export class NwMenuModule { }
